import * as React from 'react';
import { Alert } from '@grandvisionhq/common';
import { connect, withIntl, statusLoading, statusIdle } from '@grandvisionhq/state';
import Prescription from '../../components/Prescription/Prescription.js';
import { PrescriptionLoader } from '../../components/PrescriptionLoader/PrescriptionLoader.js';
import { fetchList } from '../../state/actions.js';
import { getPrescriptionListCall, getPrescriptionList } from '../../state/selectors.js';
import { NoPrescription } from '../../components/NoPrescription/NoPrescription.js';

// @TODO split this into a view/container component and feed the prescriptions from the new global solution
class PrescriptionList extends React.Component {
    componentDidMount() {
        this.props.fetchList();
    }
    render() {
        const { list , listCall , intl: { getFormattedLabel  } ,  } = this.props;
        if (Array.isArray(list)) {
            return list.length > 0 ? list.map((item)=>/*#__PURE__*/ React.createElement(Prescription, {
                    key: item.id,
                    prescription: item
                })
            ) : /*#__PURE__*/ React.createElement(NoPrescription, null);
        } else if (statusLoading(listCall) || statusIdle(listCall)) {
            return /*#__PURE__*/ React.createElement(PrescriptionLoader, null);
        } else {
            return /*#__PURE__*/ React.createElement(Alert, {
                type: "error",
                message: getFormattedLabel('account.prescriptions.errors.general', {
                    parseLink: true
                })
            });
        }
    }
}
const mapStateToProps = (state)=>({
        listCall: getPrescriptionListCall(state),
        list: getPrescriptionList(state)
    })
;
const mapDispatchToProps = {
    fetchList
};
var PrescriptionsList = connect(mapStateToProps, mapDispatchToProps)(withIntl(PrescriptionList));

export { PrescriptionList, PrescriptionsList as default, mapDispatchToProps, mapStateToProps };
//# sourceMappingURL=InlinePrescriptionsList.js.map
